import * as XSS from 'xss'
import { FilterXSS } from 'xss'

/**
 * We keep all default whitelist rules from XSS and extend them only where
 * needed to support styling, analytics tracking, and secure anchor behavior.
 */
const defaultWhiteList = { ...XSS.whiteList }

const stylingAttributes = ['class']
const analyticsAttributes = [
  'data-analytics',
  'data-psn-analytics',
  'data-psn-container'
]
// `style` is allowed only on text elements and only carries properties in the
// `css.whiteList` below (text-align), which XSS's CSS filter enforces. This
// preserves authored text alignment without opening a general style-injection
// surface.
const alignableAttributes = [...stylingAttributes, 'style']

const mergedWhiteList = {
  ...defaultWhiteList,

  div: [
    ...(defaultWhiteList.div ?? []),
    ...alignableAttributes,
    ...analyticsAttributes
  ],

  h1: [...(defaultWhiteList.h1 ?? []), ...alignableAttributes],
  h2: [...(defaultWhiteList.h2 ?? []), ...alignableAttributes],
  h3: [...(defaultWhiteList.h3 ?? []), ...alignableAttributes],
  h4: [...(defaultWhiteList.h4 ?? []), ...alignableAttributes],
  h5: [...(defaultWhiteList.h5 ?? []), ...alignableAttributes],
  h6: [...(defaultWhiteList.h6 ?? []), ...alignableAttributes],
  p: [...(defaultWhiteList.p ?? []), ...alignableAttributes],
  a: Array.from(
    new Set([
      ...(defaultWhiteList.a ?? []),
      'class',
      'id',
      'name',
      'href',
      'target',
      'rel',
      'aria-label',
      ...analyticsAttributes
    ])
  ),

  span: [...(defaultWhiteList.span ?? []), 'class', 'aria-hidden'],

  sup: [...(defaultWhiteList.sup ?? [])],
  em: [...(defaultWhiteList.em ?? [])],
  table: [...(defaultWhiteList.table ?? []), ...stylingAttributes],
  thead: [...(defaultWhiteList.thead ?? []), ...stylingAttributes],
  tbody: [...(defaultWhiteList.tbody ?? []), ...stylingAttributes],
  tr: [...(defaultWhiteList.tr ?? []), ...stylingAttributes],
  th: [...(defaultWhiteList.th ?? []), ...stylingAttributes],
  td: [...(defaultWhiteList.td ?? []), ...stylingAttributes]
}

const xss = new FilterXSS({
  whiteList: mergedWhiteList,
  css: { whiteList: { 'text-align': true } }
})

export function rteContentFilter(input: string): string {
  return xss.process(String(input ?? ''))
}
